
import "./ProfileViewDetailsLayoutComponent.scss";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {setCurrentNavParams} from "../../../../store/actions/navigation.action";
import ProfileBasicDetailsComponent from "../profile-basic-details/ProfileBasicDetailsComponent";

interface ProfileViewDetailsLayoutComponentProps {

}

// const ClientDetailsSteps: any[] = ["basicDetails", "medicalHistoryQuestionnaire", "accountDetails"];

const ProfileViewDetailsLayoutComponent = (props: ProfileViewDetailsLayoutComponentProps) => {
    // const [currentTab, setCurrentTab] = useState<any>("basicDetails");
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // useEffect(() => {
    //     let currentTab: any = searchParams.get("currentStep");
    //     if (currentTab) {
    //         if (!ClientDetailsSteps.includes(currentTab)) {
    //             currentTab = "basicDetails";
    //         }
    //     } else {
    //         currentTab = "basicDetails";
    //     }
    //     setCurrentTab(currentTab);
    // }, [searchParams]);

    useEffect(() => {
        // if (clientId) {
        //     dispatch(getClientMedicalDetails(clientId));
        //     dispatch(getClientAccountDetails(clientId));
        // }
    }, [dispatch])


    useEffect(() => {
        const referrer: any = searchParams.get("referrer");
        dispatch(setCurrentNavParams("Client Details", null, () => {
            if (referrer) {
                navigate(referrer);
            } else {
                // navigate(CommonService._routeConfig.ClientList());
            }
        }));
    }, [searchParams, navigate, dispatch]);

    // const handleTabChange = useCallback((e: any, value: any) => {
    //     searchParams.set("currentStep", value);
    //     setSearchParams(searchParams);
    //     setCurrentTab(value);
    // }, [searchParams, setSearchParams]);


    return (
        <div className='client-details-tabs-wrapper'>
            <ProfileBasicDetailsComponent/>

        </div>
    );

};

export default ProfileViewDetailsLayoutComponent;

// {/*<TabsWrapperComponent>*/}
//                     {/*<TabsComponent*/}
//                     //     value={currentTab}
//                     //     allowScrollButtonsMobile={false}
//                     //     variant={"fullWidth"}
//                     //     onUpdate={handleTabChange}
//                     // >
//                     //     <TabComponent className={'client-details-tab'} label="Client Details"
//                     //                   value={"basicDetails"}/>
//                     //     <TabComponent className={'client-details-tab'}
//                     //                   label="Medical History Questionnaire"
//                     //                   value={"medicalHistoryQuestionnaire"}/>
//                     //     <TabComponent className={'client-details-tab'} label="Account Details"
//                     //                   value={"accountDetails"}/>
//                     // </TabsComponent>
//                     {/*<TabContentComponent value={"basicDetails"} selectedTab={currentTab}>*/}
//
//                     {/*</TabContentComponent>*/}
//                     {/*<TabContentComponent value={"medicalHistoryQuestionnaire"}*/}
//                                          // selectedTab={currentTab}>
//                         {/*<ClientMedicalDetailsComponent/>*/}
//                     {/*</TabContentComponent>*/}
//                     {/*<TabContentComponent value={"accountDetails"} selectedTab={currentTab}>*/}
//                     {/*    <ClientAccountDetailsComponent />*/}
//                     {/*</TabContentComponent>*/}
//                 {/*</TabsWrapperComponent>*/}
